<template lang='pug'>
.not-found-container
  h1 Not Found

  .logo
    include ../assets/PrintOS.svg
</template>

<style lang='scss'>
  @use '~@printos/agnostic-styles/src/mixins' as *;

  .not-found-container {
    @include flex-column(center, center);

    .logo {
      width: 400px;
      max-width: 100%;

      color: $hp-blue;
    }
  }
</style>
